import {
  FETCH_LOGIN_ENABLED_SUCCESS,
  FETCH_LOGIN_ENABLED_FAILURE,
  ADD_CLASS_NAME,
} from '../../constants'

export default function LoginStatusReducer(state = {}, {
  type, loginEnabled, error, payload,
} = {}) {
  switch (type) {
    case FETCH_LOGIN_ENABLED_SUCCESS: {
      return {
        ...state,
        loginEnabled,
      }
    }
    case ADD_CLASS_NAME: {
      return {
        ...state,
        payload,
      }
    }
    case FETCH_LOGIN_ENABLED_FAILURE: {
      return {
        ...state,
        error,
      }
    }
    default:
      return state
  }
}
